import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import { Button, Modal } from 'carbon-components-react';
import { ArrowUp16 } from '@carbon/icons-react';
import { connect } from 'react-redux';
import { CFCProps, APP_URL, SCREEN_SIZE } from 'types';
import { MainContainer } from 'layouts/components';
import _ from 'lodash';
import CLOModalDetails from './CLOModalDetails';
import CLOModalSection from './CLOModalSection';
import OldCLOModalListing from './OldCLOModalListing';
import OldCLOModalSection from './OldCLOModalSection';
import OldCLOModalDetails from './OldCLOModalDetails';

const connector = connect();
type Props = CFCProps<typeof connector>;

export const CLOModal: React.FC<Props | any> = ({
  isOpen,
  onClose,
  enquiryDetail,
  ...props
}) => {
  // function start
  const { screenSize }: any = props;
  const history = useHistory();
  const [toShow, setToShow] = useState<string>('enquiryDetails');
  const [CLODetailsId, setCLODetailsId] = useState<number>(0);
  const [from, setFrom] = useState<string>('');
  const [searchText, setSearchText] = useState<any>('');
  const [order, setOrder] = useState<string>('1');
  const [withHidden, setWithHidden] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageOffset, setPageOffset] = useState<number>(0);
  const searchParams = history?.location?.search;
  const showStandaloneCLOlisting = searchParams.includes('?show=cloListing');
  const [querySeed, setQuerySeed] = useState<string>('');
  const [addressState, setAddressState] = useState<string[]>([]);

  const goToMyEnquiryPage = () => {
    history.push({
      pathname: APP_URL.ENQUIRIY_HISTORY,
      search: `?enquiryId=${enquiryDetail?.id}`
    });
  };

  const goToTop = () => {
    const ele = document.getElementById('enquiryDetails');
    if (ele) {
      ele.scrollIntoView();
    }
  };

  const changeView = (view: string) => {
    setToShow(view);
  };

  const handleBackButtonClick = () => {
    setCLODetailsId(0);
    if (from === 'listing') {
      if (showStandaloneCLOlisting) {
        changeView('cloListingStandalone');
      } else {
        changeView('cloListing');
      }
    } else {
      changeView('enquiryDetails');
    }
    setFrom('');
  };

  const handleCLOTileClick = (cloId: number) => {
    setCLODetailsId(cloId);
    changeView('cloDetails');
  };

  const handleCLOViewDetailsClick = (cloId: number, from: string = '') => {
    setCLODetailsId(cloId);
    changeView('cloDetails');
    setFrom(from);
  };

  const handleSeeALLCLOButtonClick = () => {
    changeView('cloListing');
  };

  // modal heading title
  let modalHeadingTitle = '';
  if (toShow === 'enquiryDetails') {
    modalHeadingTitle = 'Find a Locator';
  } else if (toShow === 'cloDetails') {
    modalHeadingTitle = 'Certified Locating Organisation';
  } else if (toShow === 'cloListing') {
    modalHeadingTitle =
      'All Certified Locating Organisations servicing your job site';
  }
  // function end
  // useEffect start
  useEffect(() => {
    if (showStandaloneCLOlisting) {
      changeView('cloListingStandalone');
    }
  }, [showStandaloneCLOlisting]);

  useEffect(() => {
    if (!_.isEmpty(enquiryDetail)) {
      const availableAddressStates = [
        'ACT',
        'NSW',
        'NT',
        'QLD',
        'SA',
        'TAS',
        'VIC',
        'WA'
      ];
      const defaultAddressState = availableAddressStates.includes(
        enquiryDetail.Address?.state
      )
        ? enquiryDetail.Address?.state === 'ACT' ||
          enquiryDetail.Address?.state === 'NSW'
          ? ['ACT']
          : [enquiryDetail?.Address?.state]
        : [];

      setAddressState(defaultAddressState);
    }
  }, [enquiryDetail]);
  // useEffect end

  return (
    <Modal
      open={isOpen}
      modalHeading={modalHeadingTitle}
      onRequestClose={onClose}
      passiveModal
      size="lg"
      className="clo-modal-wrapper"
    >
      <div
        id="enquiryDetails"
        data-testid="enquiryDetails"
        className="enquiryDetails--wrapper container--wrapper"
      >
        <MainContainer>
          <div className="main-wrapper">
            <div className={`left-content${isIOS ? ' is-ios' : ''}`}>
              {toShow === 'enquiryDetails' && !_.isEmpty(enquiryDetail) && (
                <React.Fragment>
                  {process.env.REACT_APP_CLO_MODAL_VERSION === 'old' ? (
                    <OldCLOModalSection
                      screenSize={screenSize}
                      handleCLOTileClick={handleCLOTileClick}
                      handleSeeALLCLOButtonClick={handleSeeALLCLOButtonClick}
                      enquiryDetail={enquiryDetail}
                      querySeed={querySeed}
                      setQuerySeed={setQuerySeed}
                      currentView={toShow}
                      isModalOpen={isOpen}
                    />
                  ) : (
                    <CLOModalSection
                      enquiryDetail={enquiryDetail}
                      handleCLOViewDetailsClick={handleCLOViewDetailsClick}
                      searchText={searchText}
                      setSearchText={setSearchText}
                      addressState={addressState}
                      setAddressState={setAddressState}
                      order={order}
                      setOrder={setOrder}
                      screenSize={screenSize}
                      withHidden={withHidden}
                      setWithHidden={setWithHidden}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageOffset={pageOffset}
                      setPageOffset={setPageOffset}
                    />
                  )}
                </React.Fragment>
              )}

              {toShow === 'cloDetails' && (
                <React.Fragment>
                  {process.env.REACT_APP_CLO_MODAL_VERSION === 'old' ? (
                    <OldCLOModalDetails
                      handleBackButtonClick={handleBackButtonClick}
                      CLODetailsId={CLODetailsId}
                    />
                  ) : (
                    <CLOModalDetails
                      handleBackButtonClick={handleBackButtonClick}
                      CLODetailsId={CLODetailsId}
                    />
                  )}
                </React.Fragment>
              )}

              {(toShow === 'cloListing' ||
                toShow === 'cloListingStandalone') && (
                <React.Fragment>
                  <OldCLOModalListing
                    handleBackButtonClick={
                      showStandaloneCLOlisting
                        ? () => {}
                        : handleBackButtonClick
                    }
                    enquiryDetail={enquiryDetail}
                    handleCLOViewDetailsClick={handleCLOViewDetailsClick}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    order={order}
                    setOrder={setOrder}
                    screenSize={screenSize}
                    withHidden={withHidden}
                    setWithHidden={setWithHidden}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageOffset={pageOffset}
                    setPageOffset={setPageOffset}
                    isStandloneCLOListing={showStandaloneCLOlisting}
                    goToMyEnquiryPage={goToMyEnquiryPage}
                    querySeed={querySeed}
                    setQuerySeed={setQuerySeed}
                  />
                </React.Fragment>
              )}
              {screenSize === SCREEN_SIZE.SM && (
                <div
                  className={`enquiryDetails--go-to-top-btn ${
                    toShow === 'enquiryDetails'
                      ? 'enquiryDetails--go-to-top-btn-bg-colour'
                      : ''
                  }`}
                >
                  <Button
                    kind="tertiary"
                    hasIconOnly
                    renderIcon={ArrowUp16}
                    iconDescription="Go to top"
                    onClick={goToTop}
                  />
                </div>
              )}
            </div>
          </div>
        </MainContainer>
      </div>
    </Modal>
  );
};

export default connector(CLOModal);
